import React from 'react';

interface Alert {
  id: string;
  type: string;
  severity: string;
  title: string;
  message: string;
  createdAt: string;
}

interface AlertsBannerProps {
  alerts: Alert[];
  onDismiss: (alertId: string) => void;
}

const AlertsBanner: React.FC<AlertsBannerProps> = ({ alerts, onDismiss }) => {
  if (alerts.length === 0) return null;

  return (
    <div className="bg-red-50 border-l-4 border-red-500 p-4 mb-6">
      <div className="flex items-start">
        <div className="flex-shrink-0">
          <svg
            className="h-6 w-6 text-red-500"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
            />
          </svg>
        </div>
        <div className="ml-3 flex-1">
          <h3 className="text-sm font-medium text-red-800">
            {alerts.length} Critical Alert{alerts.length > 1 ? 's' : ''} Require Attention
          </h3>
          <div className="mt-2 text-sm text-red-700 space-y-2">
            {alerts.map((alert) => (
              <div key={alert.id} className="flex items-start justify-between">
                <div className="flex-1">
                  <p className="font-semibold">{alert.title}</p>
                  <p className="text-xs text-red-600 mt-1">{alert.message}</p>
                </div>
                <button
                  onClick={() => onDismiss(alert.id)}
                  className="ml-4 text-red-800 hover:text-red-900 font-medium text-xs whitespace-nowrap"
                >
                  Dismiss
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AlertsBanner;
